// extracted by mini-css-extract-plugin
export var indeterminate = "_5g-5";
export var md = "_5g-4";
export var semantic = "_5g-6";
export var sm = "_5g-3";
export var text = "_5g-7";
export var toggleInput = "_5g-0";
export var toggleSwitch = "_5g-1";
export var xs = "_5g-2";